import React, { useEffect, useRef } from 'react';
import Link from 'components/commercetools-ui/atoms/link';
import Breadcrumb from 'components/commercetools-ui/molecules/breadcrumb';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { desktop } from 'helpers/utils/screensizes';
import { Category as CategoryFromEntity } from 'types/entity/category';
import TextOnlyBannerContent, { ContentItem } from './components/TextOnlyBannerContent';

export interface TnCTextOnlyProps {
  headingTitile?: string;
  breadcrumbText?: string;
  breadCrumbsHome?: string;
  content?: ContentItem[];
  inModal?: boolean;
}

const TnCTextOnlyBanner: React.FC<TnCTextOnlyProps> = ({
  headingTitile,
  content,
  breadCrumbsHome,
  breadcrumbText,
  inModal
}) => {
  const [isDesktopSize] = useMediaQuery(desktop);
  const homeBreadCrumb = {
    name: breadCrumbsHome || 'Home',
    categoryId: '_home',
    _url: '/',
  } as CategoryFromEntity;

  const footerHeadingRef = useRef<HTMLHeadingElement>(null);

useEffect(() => {
  if (!content?.length) return;

  const timer = setTimeout(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }, 10);

  return () => clearTimeout(timer);
}, [content]);

  if (inModal) {
    return (
      <div className="w-full">
        <TextOnlyBannerContent items={content ?? []} />
      </div>
    );
  }

  return (
    <div className="mx-20 sm:mx-24 md:mx-75 lg:mx-76 xl:mx-0">
      <div className="container">
        <Breadcrumb backCategory={homeBreadCrumb} listClassName="w-fit">
          <Link link="/" className="max-w-170 truncate text-14 lg:max-w-250" data-ffid="lnk-breadcrumb-link-0">
            <p title="Home" data-ffid="lbl-breadcrumb-title-0" className="text-14">
              {homeBreadCrumb?.name}
            </p>
          </Link>
          <p
            className="max-w-170 cursor-default truncate text-14 font-bold lg:max-w-250"
            title={breadcrumbText}
            data-ffid="lbl-breadcrumb-title"
          >
            {isDesktopSize && breadcrumbText}
          </p>
        </Breadcrumb>
      </div>
      <div className="container w-full" data-ffid="ctr-text-only-banner">
        <div className="w-full items-center justify-center gap-0">
          <div className={``}>
            <div className={`section-heading`} data-ffid="ctr-text-only-banner-heading">
              <div>
                <h2
                  ref={footerHeadingRef}
                  tabIndex={-1}
                  className={`whitespace-normal break-words py-20 text-center text-28 text-[#333] lg:text-40`}
                  data-ffid={`lbl-text-only-banner-heading-text`}
                >
                  {headingTitile}
                </h2>
              </div>
            </div>
          </div>
        </div>
        {content && (
          <div className="w-full items-center justify-center gap-0 py-20 lg:pb-68 lg:pt-40">
            <TextOnlyBannerContent items={content} />
          </div>
        )}
      </div>
    </div>
  );
};

export default TnCTextOnlyBanner;
